import MyCompany from "../../main/modules/Company/pages/MyCompany";
import List from "../../main/modules/Company/pages/List";
import CompanyEdit from "../../main/modules/Company/pages/CompanyEdit";

const companyLayoutRoutes = [
    {
        path: "my",
        name: "MyCompany",
        component: MyCompany,
        meta: {
            isAuth: true,
            module: "companies",
            subModule: "my"
        }
    },
    {
        path: "",
        name: "ListCompany",
        component: List,
        meta: {
            isAuth: true,
            module: "companies",
            subModule: ""
        }
    },
    {
        path: "edit",
        name: "CompanyEdit",
        component: CompanyEdit,
        meta: {
            isAuth: true,
            module: "companies",
            subModule: ""
        }
    }
]

export default companyLayoutRoutes;